import { render } from "./ImportReportsList.vue?vue&type=template&id=07bc2cf3"
import script from "./ImportReportsList.vue?vue&type=script&lang=js"
export * from "./ImportReportsList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__